import history from '../../../../history';
import { extractDataFromArray, extractNameFromArray, showFormatedDate, showFormattedTime, showFormatedDateandTime, alertConfirmation, CWABA, ADAMANTSERVICES, UPLUS, LINKTOLEARN, VICTORIOUSLEARNING, VIP, LITTLELEMONS, ABAORLANDO, TIIBA, AMEGO, KNOWBOUNDARIES, POPPYSPROMISE, CWO, IAT, HELPINGHANDS, FUTURES, AMEGOFL, ADASTRA, ALLIUM, showFormatedDateandTimeForSessionLogs, showErrorMessage, SBS, ABCSPECTRUM } from '../../../../actions/utilAction';
import { Field, reduxForm, change } from 'redux-form';
import { createClaimAction, getAppointmentById, getMasterData, getSoapAction, saveEncounterSigns, savePatientSoapAction, updateServiceCodeBlockedUnits, saveClockInTimeIntoAppointment, saveClockOutTimeIntoAppointment, getPreviousSessionNotesDetails, generateNarrativeSummary, clearNarrativeSummary } from './actions/soapActions';
import { getPatientProfileDetails } from '../../../patients/actions/PatientActions';
import React, { Component } from 'react';
import { renderCheckBox, renderTextArea, renderTimePicker } from '../../../../components/reduxFields';
import { CancelButton, CommonButton } from '../../../../components/buttons';
import { getAppConfigList, getGeoLocation, getGeoLocationClockIn, getGeoLocationClockOut } from '../../../AppConfig/actions';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import classNames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';
import PatientInfo from '../../../patients/patient_info';
import ProblemModal from './soap_daignosisModal';
import CPTModal from './soap_CPTModal';
import SignatureModal from './signature_modal';
import SignatureWithRenderingProviderModal from './signatureWithRenderingProvider_modal';
import Alert from 'react-s-alert';
import RaisedButton from 'material-ui/RaisedButton';
import UploadDocumentModal from '../../UploadDocument_Modal';
import SessionAuditLogModal from '../../SessionAuditLogModal';
import ConfirmationPopUpModal from '../confirmationPopUpModal';
import { delay } from 'lodash';
import Tooltip from 'material-ui/internal/Tooltip';


const validateSubjective = (value) => !(value ? value.trim() : value) ? 'Please enter subjective.' : undefined;
const validateObjective = (value) => !(value ? value.trim() : value) ? 'Please enter objective.' : undefined;
const validateAssessment = (value) => !(value ? value.trim() : value) ? 'Please enter assessment.' : undefined;
const validatePlans = (value) => !(value ? value.trim() : value) ? 'Please enter plan.' : undefined;
const validateNarrativeSummary = (value) => !(value ? value.trim() : value) ? 'Please enter notes' : undefined; 

// const validate = (values) => {
//   const errors = {};

//   if (!values.subjective || values.subjective.trim() == '') {
//     errors.subjective = 'Please enter subjective.';
//   }

//   if (!values.objective || values.objective.trim() == '') {
//     errors.objective = 'Please enter objective.';
//   }

//   if (!values.assessment || values.assessment.trim() == '') {
//     errors.assessment = 'Please enter assessment.';
//   }

//   if (!values.plans || values.plans.trim() == '') {
//     errors.plans = 'Please enter plans.';
//   }

//   return errors;
// };


class Soap extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      FormProps:null,
      fixedHeader: true,
      height: '200px',
      //dataCollectionHeight: '300px',
      selectable: false,
      fixedFooter: false,
      DateTimeOfVisit: '',
      patientObj: [],
      master_data: props.master_data,
      firstName: '',
      middleName: '',
      lastName: '',
      fullName: '',
      patient_id: null,
      apptid: parseInt(props.match.params.apptId, 10),
      encounterId: parseInt(props.match.params.encId, 10),
      isAdminUpdateAfterRendered: parseInt(props.match.params.isAdminUpdate, 10),
      isGenerateClaimAfterRendered: parseInt(props.match.params.isGenerateClaim, 10),
      staffID: null,
      renderingProviderID: null,
      renderingProviderName: '',
      appointmentDate: '',
      appointmentTime: '',
      staffName: '',
      patientName: '',
      appointmentTypeName: '',
      appointmentTypeID: null,
      payerName: '',
      appointmentTypeIsBillable: false,
      serviceFacility: '',
      isDirectService: false,
      genderID: null,
      diagnosisArray: [],
      patientSessionNotesSkillsAcquisitionDataArr: [],
      patientSessionNotesBehaviorReductionDataArr: [],
      PatientLocationID: null,
      PatientLocationName: '',
      open: false,
      openCPT: false,
      openRenderModal: false,
      openSign: false,
      soapPage: false,
      attachment: [],
      icdArray: [],
      DateOfService: '',
      master_CPT: props.master_data.masterCPT ? props.master_data.masterCPT : [],
      attachedDiagnosisArray: [],
      get_soap: null,
      serviceStartTime: '',
      serviceEndTime: '',
      appointment: null,
      ParentAppointmentID: null,
      appointmentStartDateTime: '',
      appointmentEndDateTime: '',
      CPTTableData: [],
      EmployeeSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      RenderingProviderSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      signRequired: {
        employee_sign: false,
        client_sign: false,
        guardian_sign: false,
        rederingProvider_sign: false,
      },
      showCompleteButton: false,
      isAllSigned: false,
      isSoapCompleted: false,
      isBillableEncounter: false,
      signatureStaffs: [],
      signatureRenderingProviders: [],
      clockInDateTime: '',
      clockOutDateTime: '',
      isServiceTimeOver: false,
      patientInsuranceId: null,
      isEvvPayer: false,
      openUploadDocument: false,
      uploadDocumentObj: null,
      // isAdminUpdateAfterRendered: false,
      isEditServiceCode: false,
      isSavedAsDraft : false,
      CPTSingleData: {},
      IsHideOnlyCompleteButton: false,
      isFormSubmitted: false,
      isDataCollectionEnabledForAgency : false,
      openSessionAuditLogModal: false,
      lastUpdatedBy: '',
      lastUpdatedDate: '',
      RestrictSignaturesBeforeAppointmentEndTime: false,
      isSessionPending: false,
      reasonCodeState:"",
      isClockInClockOutMandate:false,
      showClockInClockOut:false,
      soapNoteDataFromModal:null,
      requiredFields : {
        'subjective' : '',
        'objective': '',
        'assessment': '',
        'plans': '',
      },
      isGenerateAIDisabled: false,
      narrativeAISummaryResponse: null,
      narrativeAISummaryError: null,
      isGeneratingNarrativeSummary: false,
      isTooltipVisible: false,
    });
    this.filter = {
      isClientSigned: false,
      isEmployeeSigned: false,
      isGuardianSigned: false,
      isRenderingProviderSigned: false,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.renderDiagnosis = this.renderDiagnosis.bind(this);
    this.renderCpt = this.renderCpt.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCompleteSoap = this.onCompleteSoap.bind(this);
    this.handleClockIn = this.handleClockIn.bind(this);
    this.onSaveAsDraft = this.onSaveAsDraft.bind(this);
  };

  componentWillMount() {
    this.props.getMasterData();
    // this.props.getPatientDetailsById(this.state.patient_id);
    if (this.state.apptid) {
      // this.props.getAppointmentById(this.state.apptid);
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getSoapAction(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }
    // let patientInsuranceId = this.props.get_soap && this.props.get_soap.data && this.props.get_soap.data.patientAppointment &&this.props.get_soap.data.patientAppointment.patientInsuranceId;
    // let appointmentTypeId = this.props.get_soap && this.props.get_soap.data && this.props.get_soap.data.patientAppointment &&this.props.get_soap.data.patientAppointment.appointmentTypeID;
    // this.props.getAppConfigList(patientInsuranceId, appointmentTypeId);
    
    this.props.app_config.forEach((obj)=>{ 
        if(obj.key === "SHOW_CLOCKIN_CLOCKOUT_ON_SESSION_NOTE"){
          this.setState({showClockInClockOut:obj.value})
        }
        
        if(obj.key === "REQUIRED_CLOCKIN_CLOCKOUT_ON_SESSION_NOTE") {
          this.setState({isClockInClockOutMandate:obj.value}) 
        }  
    })

    if (this.props.get_soap&&this.props.get_soap.data&&this.props.get_soap.data.notetypeId!==0) {
      this.setState({FormProps:this.props.get_soap.data})
      delay(()=>{
        this.formatedSoapData(this.props.get_soap);
      },100) 
    }
  
  }

    componentWillUnmount() {
      // Clear the narrative summary when unmounting
      this.props.clearNarrativeSummary();
      this.props.dispatch(change('soapForm', 'narrativeSummary', ''));
      this.setState({
        narrativeAISummaryResponse: null
      });
    }

  componentDidUpdate(prevProps){
    if (this.props.get_soap !== prevProps.get_soap) {
      let patientInsuranceId = this.props.get_soap && this.props.get_soap.data && this.props.get_soap.data.patientAppointment &&this.props.get_soap.data.patientAppointment.patientInsuranceId;
      let appointmentTypeId = this.props.get_soap && this.props.get_soap.data && this.props.get_soap.data.patientAppointment &&this.props.get_soap.data.patientAppointment.appointmentTypeID;
      this.props.getAppConfigList(patientInsuranceId, appointmentTypeId);
    }
  }


  handleFieldChange = (fieldName, value) => {
    if(Object.keys(this.state.requiredFields).includes(fieldName)){

      this.state.requiredFields[fieldName] = value;
    }
    let checkValueExist = Object.values(this.state.requiredFields).every((value) => value.trim() !== '');
    this.setState({
      isGenerateAIDisabled : checkValueExist
    })
  }
  
  formPropDataPusher= ()=>{
    console.log(this.state.FormProps);
    
    if(this.state.FormProps!==null){
      return this.state.FormProps
    }
    return null
  }

  uploadDocumenthandler = () => {
    Alert.closeAll();
    this.setState({ openUploadDocument: true, uploadDocumentObj: null });
  }

  handleCloseHandler = () => {
    this.setState({ openUploadDocument: false });
  };

  handleCancel() {
    if(this.props.previousLocation!==null){
      history.push(this.props.previousLocation);
    }
    else{
      history.push('/scheduling');
    } 
  }

  handleAlertClick = (event) => {
    this.setState({clockInDateTime : moment.utc().format('YYYY-MM-DDTHH:mm:ss')},()=>{ this.props.getGeoLocationClockIn(); });    
    Alert.closeAll();
  };

  handleClockIn = (event) => {
    let warningMsg = 'Are you sure you want to clock-in ? You can only do it once. You should be at the location where session is taking place';
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick       
      },
    });
  };

  handleClockOutAlertClick = (event) => {
    this.setState({clockOutDateTime : moment.utc().format('YYYY-MM-DDTHH:mm:ss')},()=>{ this.props.getGeoLocationClockOut(); });    
    Alert.closeAll();
  };

  handleClockOut = (event) => {
    let warningMsg = 'Are you sure you want to clock-out ? You can only do it once. You should be at the location where session is taking place';
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleClockOutAlertClick       
      },
    });
  };

  handleOpenSessionAuditLog = (event) => {    
    this.setState({
      openSessionAuditLogModal: true     
    });
  }

  handleCloseSessionAuditLogModal = () => {
    this.setState({
      openSessionAuditLogModal: false
    });
  }

  handleMouseEnter = () => {
    if(!this.state.isGenerateAIDisabled){
      this.setState({isTooltipVisible : true})
    }
  }

  handleMouseLeave = () => {
    this.setState({isTooltipVisible : false})
  }

  formatedSoapData(soapDetail) {
    if (soapDetail) {
      let soapObj = soapDetail.data;
      // bind appointment data .....
      let appointmentData = soapObj.patientAppointment;
      let staffIds = [];
      let staffNames = [];
      let signatureStaffs = [];      
      appointmentData.appointmentSingleStaff.forEach((staff) => {
        staffNames.push(staff.staffName);
        staffIds.push(staff.staffId);
        signatureStaffs.push({ 'id': staff.staffId, 'value': staff.staffName });
      });

      let renderingProviderIds = [];
      let renderingProviderNames = [];
      let signatureRenderingProviders = [];      

      appointmentData.appointmentRenderingProviders.forEach((staff) => {
        renderingProviderNames.push(staff.renderingProviderName);
        renderingProviderIds.push(staff.renderingProviderId);
        signatureRenderingProviders.push({ 'id': staff.renderingProviderId, 'value': staff.renderingProviderName });
      });

      let patientSessionNotesSkillsAcquisitionData = [];
        if (appointmentData.patientSessionNotesSkillsAcquisitionData && appointmentData.patientSessionNotesSkillsAcquisitionData.length) {          
          appointmentData.patientSessionNotesSkillsAcquisitionData.forEach((obj, index) => {
            patientSessionNotesSkillsAcquisitionData.push({
              'Id': obj.targetId,
              'programName': obj.programName,
              'targetName': obj.targetName,
              'targetData': obj.targetData,
            });
          });
          this.setState({
            patientSessionNotesSkillsAcquisitionDataArr: patientSessionNotesSkillsAcquisitionData,
          });                    
        }
        let patientBehaviorReductionData = [];
        if (appointmentData.patientBehaviorReductionData && appointmentData.patientBehaviorReductionData.length) {          
          appointmentData.patientBehaviorReductionData.forEach((obj, index) => {
            patientBehaviorReductionData.push({
              'Id': obj.behaviorsReductionId,
              'behaviorName': obj.behaviorName,
              'recordingTypeName': obj.recordingTypeName,
              'behaviorData': obj.behaviorData,
            });
          });
          this.setState({
            patientSessionNotesBehaviorReductionDataArr: patientBehaviorReductionData,
          });                    
        }

      let staffID = staffIds && staffIds.length ? staffIds[0] : null;
      let staffName = staffNames && staffNames ? staffNames.join(',') : '';
      let renderingProviderID = renderingProviderIds && renderingProviderIds.length ? renderingProviderIds[0] : null;
      let renderingProviderName = renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '';
      let appointmentTypeName = appointmentData.appointmentTypeName;
      let appointmentTypeID = appointmentData.appointmentTypeID;
      let payerName = appointmentData.payerName;
      let appointmentTypeIsBillable = appointmentData.isBillable;
      let appointmentDate = showFormatedDate(appointmentData.dateOfService);
      let appointmentTime = showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime);
      let patientName = appointmentData.patientName;
      // let appointmentTime = `${formattedStartTimehours}:${appointmentData.StartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${appointmentData.EndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      let PatientLocationID = '';
      let PatientLocationName = appointmentData.address;
      if (!appointmentTypeIsBillable) {
        this.setState({ isAllSigned: true });
      }
      // to get the patient info panel ..
      if (appointmentData.patientID) {
        this.props.getPatientProfileDetails(appointmentData.patientID);
      }

      this.setState({
        appointment: appointmentData,
        ParentAppointmentID: appointmentData.parentAppointmentId,
        staffID: staffID,
        staffName: staffName,
        renderingProviderID: renderingProviderID,        
        renderingProviderName: renderingProviderName,
        patient_id: appointmentData.patientID,
        patientName: patientName,
        appointmentTypeName: appointmentTypeName,
        appointmentTypeID: appointmentTypeID,
        payerName: payerName,
        appointmentTypeIsBillable: appointmentTypeIsBillable,
        appointmentDate: appointmentDate,
        appointmentTime: appointmentTime,
        DateTimeOfVisit: `${appointmentDate}, ${appointmentTime}`,
        PatientLocationName: PatientLocationName,
        PatientLocationID: PatientLocationID,
        DateOfService: appointmentData.startDateTime,
        appointmentStartDateTime: appointmentData.startDateTime,
        appointmentEndDateTime: appointmentData.endDateTime,
        serviceStartTime: appointmentData.startDateTime,
        serviceEndTime: appointmentData.endDateTime,
        showCompleteButton: appointmentTypeIsBillable && this.state.encounterId && ((appointmentData.claimId > 0 || appointmentData.isSavedAsDraft === false) ? true : false),
        isBillableEncounter: appointmentData.isBillable,
        signatureStaffs: signatureStaffs,
        signatureRenderingProviders: signatureRenderingProviders,
        serviceFacility: appointmentData.serviceFacility,
        isDirectService: appointmentData.isDirectService,
        claimId: appointmentData.claimId,
        isAdminUpdateAfterRendered: (appointmentData.claimId && appointmentData.canEdit),
        clockInDateTime: appointmentData.clockInDateTime,
        isServiceTimeOver: appointmentData.isServiceTimeOver,
        patientInsuranceId: appointmentData.patientInsuranceId,
        clockOutDateTime: appointmentData.clockOutDateTime,
        isEvvPayer: appointmentData.isEvvPayer ||  appointmentData.clockInAndClockOutEVV,
        isSavedAsDraft: appointmentData.isSavedAsDraft,
        isFormSubmitted: appointmentTypeIsBillable && this.state.encounterId && appointmentData.isSavedAsDraft === false ? true : false,
        isDataCollectionEnabledForAgency: appointmentData.isDataCollectionEnabledForAgency,
        lastUpdatedBy : soapObj.lastUpdatedBy,
        lastUpdatedDate : soapObj.lastUpdatedDate,
      }, () => {
        if (soapObj.id && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
          // this.setState({
          //   serviceStartTime: soapObj.startDateTime,
          //   serviceEndTime: soapObj.endDateTime,
          // });
        }
        let icdArray = [];
        if (soapObj.patientEncounterDiagnosisCodes && soapObj.patientEncounterDiagnosisCodes.length) {          
          soapObj.patientEncounterDiagnosisCodes.forEach((obj, index) => {
            icdArray.push({
              'DiagnosisDate': moment(obj.diagnosisDate).format(),
              'Description': obj.description,
              'ICDCodeId': obj.icdCodeId,
              'ICDCode': obj.icdCode,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
            });
          });
          this.setState({
            diagnosisArray: icdArray,
          });                    
        }
        let cptArray = [];
        if (soapObj.patientEncounterServiceCodes && soapObj.patientEncounterServiceCodes.length) {
          soapObj.patientEncounterServiceCodes.forEach((obj, index) => {
            cptArray.push({
              'AuthProcedureCPTLinkId': obj.authProcedureCPTLinkId,
              'AuthorizationNumber': obj.authorizationNumber,
              'ServiceCodeId': obj.serviceCodeId,
              'ServiceCode': obj.serviceCode,
              'Description': obj.description,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
              'Modifier1': obj.modifier1,
              'Modifier2': obj.modifier2,
              'Modifier3': obj.modifier3,
              'Modifier4': obj.modifier4,
              'AttachedModifiers': obj.attachedModifiers,
              //'Quantity': obj.quantity,
              'Quantity': obj.quantity > 0 ? obj.quantity : null,
              'RemainingUnits': obj.remainingUnits,
            });
          });
        }
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              this.filter.isGuardianSigned = true;
              this.setState({ GuardianSign: data });
            }
            if (signObj.patientSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: this.state.patientName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              this.filter.isClientSigned = true;
              this.setState({ ClientSign: data });
            }
            if (signObj.clinicianSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: this.state.staffName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              this.filter.isEmployeeSigned = true;
              this.setState({ EmployeeSign: data });
            }
            if (signObj.renderingProviderSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.renderingProviderSign,
                Date: signObj.renderingProviderSignDate,
                //Name: this.state.renderingProviderName,
                Name: signObj.renderingProviderName ? signObj.renderingProviderName : this.state.renderingProviderName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              this.filter.isRenderingProviderSigned = true;
              this.setState({ RenderingProviderSign: data });
            }            
          });
        }
        if ((soapObj.status || '').toLowerCase() === 'rendered' && appointmentData.claimId && !this.state.isSavedAsDraft) {
          if (this.state.isAdminUpdateAfterRendered !== undefined && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
            this.setState({ isSessionPending: false, isSoapCompleted: true, isAllSigned: true });
          } else {
            this.setState({ isAllSigned: true });
          }
        } else if ((soapObj.status || '').toLowerCase() === 'rendered' && !appointmentData.claimId && !this.state.isSavedAsDraft &&soapObj.notetypeId!==0) {
          this.setState({ isSessionPending: true });

        } else if ((soapObj.status || '').toLowerCase() === 'pending' && !this.state.isSavedAsDraft &&soapObj.notetypeId!==0) {
            this.setState({ isSessionPending: true });
        }
        if (!this.filter.isGuardianSigned) {
          let employee_signRequired = this.state.signRequired.employee_sign,
            client_signRequired = this.state.signRequired.client_sign,
            guardian_signRequired = this.state.signRequired.guardian_sign,
            rederingProvider_signRequired = this.state.signRequired.rederingProvider_sign;
          if (appointmentData && !appointmentData.isDirectService && this.state.signRequired.guardian_sign) {
            guardian_signRequired = this.props.requiredGuardianSignForIndirectServicePermission ? true : false;
          }

          this.setState({
            signRequired: {
              employee_sign: employee_signRequired,
              client_sign: client_signRequired,
              guardian_sign: guardian_signRequired,
              rederingProvider_sign: rederingProvider_signRequired,
            },
          }, () => {
            this.setState({
              isAllSigned: this.checkIsAllRequiredSigned(),
            });
          });
        }
        this.setState({
          isAllSigned: this.checkIsAllRequiredSigned(),
          get_soap: soapDetail.data,
          CPTTableData: cptArray,
          diagnosisArray: icdArray,
        },()=>{
          if(this.state.isGenerateClaimAfterRendered)
          {     
            var link = document.getElementById('btnComplete');      
            if(link)      
              link.click();            
          }
          // setTimeout(function () {               
          //   if(!this.state.encounterId || this.state.isSavedAsDraft) 
          //   {
          //     var link = document.getElementById('btnSaveAsDraft');      
          //     if(link)      
          //       link.click();         
          //   }              
          // }.bind(this), 300000); //5 min
        });
      });
    }
  }
  
  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.encId !== this.props.match.params.encId) {
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getSoapAction(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }
    
    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,
        master_CPT: nextProps.master_data.masterCPT,
      });
    }
    if (nextProps.app_config && this.props.app_config !== nextProps.app_config) {
      let app_config = nextProps.app_config;
      let employee_signRequired = false;
      let client_signRequired = false;
      let guardian_signRequired = false;
      let rederingProvider_signRequired = false;
      let restrictSignaturesBeforeAppointmentEndTime = false;
      if (app_config && app_config.length) {
        app_config.forEach((Obj) => {
          if (Obj.configType === 1) {
            switch (Obj.key) {
            case 'CLINICIAN_SIGN':
              employee_signRequired = (Obj.value.toString().toLowerCase() === 'true');
              break;
            case 'PATIENT_SIGN':
              client_signRequired = (Obj.value.toString().toLowerCase() === 'true');
              break;
            case 'GUARDIAN_SIGN':
              guardian_signRequired = (Obj.value.toString().toLowerCase() === 'true');
              break;
            case 'RENDERINGPROVIDER_SIGN':
              rederingProvider_signRequired = (Obj.value.toString().toLowerCase() === 'true');
              break;
            default:
              break;
            }
          }
          else if (Obj.configType === 4) {
            switch (Obj.key) {            
            case 'RESTRICTSIGNATURE_BEFORE_APPOINTMENT_ENDDATE':
              restrictSignaturesBeforeAppointmentEndTime = (Obj.value.toString().toLowerCase() === 'true');
              break;
            default:
              break;
            }
          }
        });
      }
      this.setState({RestrictSignaturesBeforeAppointmentEndTime : restrictSignaturesBeforeAppointmentEndTime });      
      if (!this.filter.isGuardianSigned) {
        // let isAnySignRequired = employee_signRequired || client_signRequired || guardian_signRequired;
        let patientAppointmentData = this.state.get_soap && this.state.get_soap.patientAppointment;
        // let isAppointmentRendered = this.state.get_soap && (this.state.get_soap.status || '').toLowerCase() === 'rendered';
        if (patientAppointmentData && !patientAppointmentData.isDirectService && guardian_signRequired) {
          guardian_signRequired = this.props.requiredGuardianSignForIndirectServicePermission ? true : false;
        }
        this.setState({
          // isAllSigned: !isAnySignRequired,
          signRequired: {
            employee_sign: employee_signRequired,
            client_sign: client_signRequired,
            guardian_sign: guardian_signRequired,
            rederingProvider_sign: rederingProvider_signRequired,
          },
        }, () => {
          this.setState({
            isAllSigned: this.checkIsAllRequiredSigned(),
          });
        });
      }
    }

    if (nextProps.saved_soap && this.props.saved_soap !== nextProps.saved_soap) {
      if (nextProps.saved_soap.id) {

        // Check if we need to generate narrative after save completed
        if (this.state.pendingNarrativeGeneration) {
          this.setState({ 
            pendingNarrativeGeneration: false,
            isGeneratingNarrativeSummary: true 
          }, () => {
            this.props.generateNarrativeSummary(nextProps.saved_soap.id);
          });
        }

        if (!this.state.encounterId) {
          history.push(`/soap/${this.state.apptid}/${nextProps.saved_soap.id}/${this.state.isAdminUpdateAfterRendered ? 1 : 0}/0`);
        } else {
          this.setState({ isSavedAsDraft: nextProps.saved_soap.isSavedAsDraft },() =>{
            if(nextProps.saved_soap.isSavedAsDraft)            
              this.setState({ isSoapCompleted: false});
             else {
              if (this.state.isAdminUpdateAfterRendered !== undefined && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
                this.setState({ isSessionPending: false });
              } else {
                this.setState({ isSessionPending: true});
              }
             }
          });
        }
        this.setState({ encounterId: nextProps.saved_soap.id, showCompleteButton: (this.state.claimId > 0 || nextProps.saved_soap.isSavedAsDraft === false) && this.state.appointmentTypeIsBillable ? true : false, isFormSubmitted: nextProps.saved_soap.isSavedAsDraft === false && this.state.appointmentTypeIsBillable ? true : false });
      }
    }
    if (nextProps.get_soap && this.props.get_soap !== nextProps.get_soap) {
      this.formatedSoapData(nextProps.get_soap);
    }

    if (nextProps.lastUpdatedDate && this.props.lastUpdatedDate !== nextProps.lastUpdatedDate) {
      //console.log('nextProps.lastUpdatedDate before.................', nextProps.lastUpdatedDate)      
      this.setState({ lastUpdatedDate: nextProps.lastUpdatedDate.toString().replace('Z', '') });
      //console.log('this.state.lastUpdatedDate after.................', this.state.lastUpdatedDate)      
    }

    if (nextProps.saved_EncounterSigns && nextProps.saved_EncounterSigns !== this.props.saved_EncounterSigns) {
      let signObj = nextProps.saved_EncounterSigns.data;
      if (signObj.guardianSign) {
        let data = this.state.GuardianSign;
        data.id = signObj.id;
        this.setState({ GuardianSign: data });
      }
      if (signObj.patientSign) {
        let data = this.state.ClientSign;
        data.id = signObj.id;
        this.setState({ ClientSign: data });
      }
      if (signObj.clinicianSign) {
        let data = this.state.EmployeeSign;
        data.id = signObj.id;
        this.setState({ EmployeeSign: data });
      }
      if (signObj.renderingProviderSign) {
        let data = this.state.RenderingProviderSign;
        data.id = signObj.id;
        this.setState({ RenderingProviderSign: data });
      }
    }

    if (nextProps.clockInLatitude && nextProps.clockInLatitude > 0 && this.props.clockInLatitude !== nextProps.clockInLatitude) {
      let formData = {
        'appointmentId': this.state.apptid,
        'clockInDateTime': this.state.clockInDateTime,
        'clockInLatitude' : nextProps.clockInLatitude || 0.0,
        'clockInLongitude' : nextProps.clockInLongitude || 0.0,
      }
      this.props.saveClockInTimeIntoAppointment(formData);
    }

    if (nextProps.clockOutLatitude && nextProps.clockOutLatitude > 0 && this.props.clockOutLatitude !== nextProps.clockOutLatitude) {
      let formData = {
        'appointmentId': this.state.apptid,
        'clockOutDateTime': this.state.clockOutDateTime,
        'clockOutLatitude' : nextProps.clockOutLatitude || 0.0,
        'clockOutLongitude' : nextProps.clockOutLongitude || 0.0,
      }     
      this.props.saveClockOutTimeIntoAppointment(formData);
    }

    if(nextProps.isGeneratingNarrativeSummary != null && this.state.isGeneratingNarrativeSummary != nextProps.isGeneratingNarrativeSummary)
      this.setState({ isGeneratingNarrativeSummary: nextProps.isGeneratingNarrativeSummary });
    
    if (nextProps.narrativeAISummaryResponse && this.state.narrativeAISummaryResponse !== nextProps.narrativeAISummaryResponse) {
      this.setState({ 
        narrativeAISummaryResponse: nextProps.narrativeAISummaryResponse,
      }, ()=>{
          this.props.dispatch(change('soapForm', 'narrativeSummary', nextProps.narrativeAISummaryResponse));
      });      
    }

  };

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  };

  onSaveAsDraft(formProps) {
    this.setState({isSavedAsDraft : true},() => {
      this.submitFormData(formProps);
    });       
  }

  onCompleteSoap(formProps) {
    if (!this.state.isEvvPayer && this.state.isClockInClockOutMandate==="true" && (this.state.clockInDateTime===undefined || this.state.clockOutDateTime===undefined)){
      Alert.warning('Please record clock-in and clock-out time before rendering the session', {
        position: 'bottom-right',
        effect: 'slide',
      });
      return false;
    }

    this.setState({isSavedAsDraft : false, IsHideOnlyCompleteButton: true});
    let isGenerateClaim = true;
    this.submitFormData(formProps, isGenerateClaim);
  }

  onSubmit(formProps) {
    if(this.state.isEvvPayer){
      this.setState({FormProps:formProps})
    }
    this.setState({isFormSubmitted: true},() => {
      if(this.state.appointmentTypeIsBillable === false || (formProps.subjective != undefined && formProps.subjective.trim() !== '' && formProps.objective != undefined && formProps.objective.trim() !== '' && formProps.assessment != undefined && formProps.assessment.trim() !== '' && formProps.plans != undefined && formProps.plans.trim() !== ''))
      {
        this.setState({isSavedAsDraft : false, showCompleteButton: true, isFormSubmitted: true},() => {
          this.submitFormData(formProps);
        });
      }
    });
  };

  submitFormData(formProps, isGenerateClaim = false) {
    if (!this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).length) {
      Alert.warning('Please add atleast one diagnosis!', {
        position: 'bottom-right',
        effect: 'slide',
      });
      return false;
    }
    if (this.state.appointmentTypeIsBillable) {
      if (!this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).length) {
        Alert.warning('Please add atleast one service code!', {
          position: 'bottom-right',
          effect: 'slide',
        });
        return false;
      }
    }

    let ICDArray = this.state.diagnosisArray;
    let CPTcodes = this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted);
    let formData = {
      'Id': this.state.encounterId,
      'PatientID': this.state.patient_id,
      'AppointmentStartDateTime': this.state.appointmentStartDateTime,
      'AppointmentEndDateTime': this.state.appointmentEndDateTime,
      'PatientAppointmentId': this.state.encounterId || !this.state.appointment.RecurrenceRule ? this.state.apptid : null,
      'ParentAppointmentId': this.state.encounterId ? null : this.state.ParentAppointmentID,
      'DateOfService': this.state.DateOfService,
      'StartDateTime': moment(this.state.serviceStartTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceStartTime).format('HH:mm:ss'),
      'EndDateTime': moment(this.state.serviceEndTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceEndTime).format('HH:mm:ss'),
      'StaffID': this.state.staffID,
      // 'LocationID': this.props.singleEncounter.locationID,
      'ServiceLocationID': this.state.appointment ? this.state.appointment.serviceLocationID : null,
      'OfficeAddressID': this.state.appointment ? this.state.appointment.officeAddressID : null,
      'PatientAddressID': this.state.appointment ? this.state.appointment.patientAddressID : null,
      'CustomAddressID': this.state.appointment ? this.state.appointment.customAddressID : null,
      'CustomAddress': this.state.appointment ? this.state.appointment.customAddress : null,
      'ServiceAddress': this.state.appointment ? this.state.appointment.address : null,
      // 'PatientSign': this.state.ClientSign.Bytes,
      // 'PatientSignDate': this.state.ClientSign.Date,
      // 'ClinicianSign': this.state.EmployeeSign.Bytes,
      // 'ClinicianSignDate': this.state.EmployeeSign.Date,
      // 'GuardianSign': this.state.GuardianSign.Bytes,
      // 'GuardianSignDate': this.state.GuardianSign.Date,
      // 'GuardianName': this.state.GuardianSign.Name,
      'NotetypeId': 1,

       
      'SOAPNotes': {
        'Id':this.state.soapNoteDataFromModal!==null? this.state.soapNoteDataFromModal.id:this.state.get_soap && this.state.get_soap.soapNotes ? this.state.get_soap.soapNotes.id : 0,
        'Subjective':this.state.soapNoteDataFromModal!==null? this.state.soapNoteDataFromModal.subjective:formProps.subjective ? formProps.subjective.trim() : '',
        'Objective':this.state.soapNoteDataFromModal!==null? this.state.soapNoteDataFromModal.objective:formProps.objective ? formProps.objective.trim() : '',
        'Assessment':this.state.soapNoteDataFromModal!==null? this.state.soapNoteDataFromModal.assessment:formProps.assessment ? formProps.assessment.trim() : '',
        'Plans':this.state.soapNoteDataFromModal!==null? this.state.soapNoteDataFromModal.assessment:formProps.plans ? formProps.plans.trim() : '',
        'NarrativeSummary':this.state.soapNoteDataFromModal!==null? this.state.soapNoteDataFromModal.narrativeSummary:formProps.narrativeSummary ? formProps.narrativeSummary.trim() : '',
      },
      'PatientEncounterServiceCodes': CPTcodes,
      'PatientEncounterDiagnosisCodes': ICDArray,
      'isBillableEncounter': this.state.appointmentTypeIsBillable ? true : false,
      'isSavedAsDraft': this.state.isSavedAsDraft ? true : false,
      'ReasonForRenderingFromWeb':this.state.reasonCodeState
    };
    // console.log('submit data =========', JSON.stringify(formData));
    // check for user is Admin and Soap has been rendered ...
    let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission;
    this.props.savePatientSoapAction(formData, isGenerateClaim, isAdminUpdateAfterRendered);
  }


  handleOpen = () => {
    this.setState({ open: true, soapPage: true });
  };
  handleClose = () => {
    this.setState({ open: false ,openRenderModal:false});
  };
  handleOpenCPT = () => {
    this.setState({ openCPT: true, soapPage: true, isEditServiceCode: false, CPTSingleData: {} });
  };
  handleCloseCPT = () => {
    this.setState({ openCPT: false });
  };

  handleOpenConfirmationPopUpModal =() => { 
    this.setState({openRenderModal : true})
  }

  handleGenerateAISummary = (formProps) => {
    Alert.closeAll();
    this.setState({
      isSavedAsDraft: true,
      pendingNarrativeGeneration: true
    }, () => {
      this.submitFormData(formProps);
    });   
  }
  
  handleOpenSign= () => {
    if(this.state.RestrictSignaturesBeforeAppointmentEndTime)// && !this.state.isServiceTimeOver)
    {
      // console.log('moment(this.state.appointmentEndDateTime)YYYY-MM-DDTHH:mm:ss.......',(moment(this.state.appointmentEndDateTime).format('YYYY-MM-DD') + 'T' + moment(this.state.appointmentEndDateTime).format('HH:mm:ss')))
      // console.log(' moment(new Date()YYYY-MM-DD HH:mm:ss).......',(moment(new Date()).format('YYYY-MM-DD') + 'T' + moment(new Date()).format('HH:mm:ss')))
      if(this.checkIsBefore((moment(new Date()).format('YYYY-MM-DD') + 'T' + moment(new Date()).format('HH:mm:ss')), (moment(this.state.appointmentEndDateTime).format('YYYY-MM-DD') + 'T' + moment(this.state.appointmentEndDateTime).format('HH:mm:ss'))))
      {
        showErrorMessage('Signatures are restricted until the end time of appointment. Please obtain signatures on or after the appointment end time.');
      }
      else {
        this.props.getGeoLocation();    
        this.setState({ openSign: true, soapPage: true });
      } 
    } else {
      this.props.getGeoLocation();    
      this.setState({ openSign: true, soapPage: true });
    }    
  };
  checkIsBefore = (date1, date2) => {
    return moment(date1).isBefore(date2);  
  }
  handleCloseSign = () => {
    this.setState({ openSign: false });
  };
  DiagnosisAlertClick=(e, index) => {
    Alert.closeAll();
    if (index > -1) {
      let arr = this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted);
      if (arr[index].Id > 0) {
        arr[index].IsDeleted = true;
      } else {
        arr.splice(index, 1);
      }
      this.setState({ diagnosisArray: arr });
    }
  }
  handleRemoveDiagnosisClick = (e, index) => {
    Alert.warning('Are you sure you want to remove this diagnosis?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.DiagnosisAlertClick,
        id: index,
      },
    });
  }
    CPTCodeAlertClick=(e, data) => {
    if (data.AuthProcedureCPTLinkId) {
      let postData = {
        appointmentId: this.state.apptid,
        authProcedureCPTLinkId: data.AuthProcedureCPTLinkId,
        serviceCodeId: 0,
        unitToBlock: 0,
        actionName: 'delete',
      };      
      this.props.updateServiceCodeBlockedUnits(postData);
    }
    let index = data.index;
    Alert.closeAll();
    if (index > -1) {
      let arr = this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted);
      if (arr[index].Id > 0) {
        arr[index].IsDeleted = true;
      } else {
        arr.splice(index, 1);
      }
      this.setState({ CPTTableData: arr },()=>{
        if(this.state.showCompleteButton)
        {
            var link = document.getElementById('btnComplete');      
            if(link)      
              link.click();  
        }
        else
        {            
          //save 
          var link = document.getElementById('btnSave');      
          if(link)      
            link.click();             
        }
      });
    }
  }
  handleEditCPTCodeClick = (event, obj) => {    
    let CPTData = (this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted) || []).filter((Obj) => {
      return Obj.ServiceCodeId === (obj.ServiceCodeId);
    });        
    this.setState({ openCPT: true, soapPage: true, isEditServiceCode: true, CPTSingleData: CPTData });    
  }

  handleRemoveCPTCodeClick = (e, data) => {
    Alert.warning('Are you sure you want to remove this service code?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.CPTCodeAlertClick,
        id: data,
      },
    });
  }
  renderDiagnosis() {
    if (this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).map((diagnosis, index) => {
      return (
        <TableRow key={index}>
          <TableRowColumn width="30%">{diagnosis.ICDCode}</TableRowColumn>
          <TableRowColumn width="70%">{diagnosis.Description ? diagnosis.Description : '-'}</TableRowColumn>
          {/* <TableRowColumn width="30%">{diagnosis.DiagnosisDate ? showFormatedDate(diagnosis.DiagnosisDate) : '-'}</TableRowColumn> */}
          {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
            <TableRowColumn><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button></TableRowColumn>
            : null} */}
        </TableRow>
      );
    });
  }
  renderCpt() {
    if (this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).map((cpt, index) => {
      let data = {
        index: index,
        AuthProcedureCPTLinkId: cpt.AuthProcedureCPTLinkId,
      };
      return (
        <TableRow key={index}>
          <TableRowColumn>{cpt.ServiceCode ? cpt.ServiceCode : '-'}</TableRowColumn>
          <TableRowColumn>{cpt.AttachedModifiers ? cpt.AttachedModifiers : '-'}</TableRowColumn>
          <TableRowColumn>{cpt.Quantity ? cpt.Quantity : '0'}</TableRowColumn>
          <TableRowColumn>{cpt.Description ? cpt.Description : '-'}</TableRowColumn>
          {(this.props.agencyName.toUpperCase() === CWO || this.props.agencyName.toUpperCase() === VIP) && this.props.deletePermission && !this.state.isSoapCompleted && !this.state.IsHideOnlyCompleteButton ?            
            <td width="10%">
                <button onClick={(e) => this.handleEditCPTCodeClick(e, cpt)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>  
                <button onClick={(e) => this.handleRemoveCPTCodeClick(e, data)} title="Remove" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>                
            </td>
            : null}
        </TableRow>
      );
    });
  }


  renderSessionNotesSkillsAcquisition() {
    if (this.state.patientSessionNotesSkillsAcquisitionDataArr.length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.patientSessionNotesSkillsAcquisitionDataArr.map((obj, index) => {
      return (
        <TableRow key={index}>
          <TableRowColumn width="40%">{obj.programName}</TableRowColumn>
          <TableRowColumn width="40%">{obj.targetName}</TableRowColumn>
          <TableRowColumn width="20%">{obj.targetData.toFixed(2).toString() + ' %'}</TableRowColumn>          
        </TableRow>
      );
    });
  }

  renderSessionNotesBehaviorReduction() {
    if (this.state.patientSessionNotesBehaviorReductionDataArr.length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.patientSessionNotesBehaviorReductionDataArr.map((obj, index) => {
      return (
        <TableRow key={index}>
          <TableRowColumn width="40%">{obj.behaviorName}</TableRowColumn>
          <TableRowColumn width="40%">{obj.recordingTypeName}</TableRowColumn>
          {obj.recordingTypeName.toLowerCase() === 'partial interval' || obj.recordingTypeName.toLowerCase() === 'momentary time sample' ?
          <TableRowColumn width="20%">{obj.behaviorData + ' %'}</TableRowColumn>          
          :
          <TableRowColumn width="20%">{obj.behaviorData}</TableRowColumn> }          
        </TableRow>
      );
    });
  }

  handleAddDiagnosis = (formValues) => {
    let diseaseDetails = extractDataFromArray(this.state.master_data.masterICD, formValues.ICDID);
    let arr = this.state.diagnosisArray;
    if (arr.indexOf(formValues) === -1) {
      arr.push({
        'DiagnosisDate': moment(formValues.DiagnosisDate).format(),
        'Description': diseaseDetails.description,
        'ICDCodeId': diseaseDetails.id,
        'ICDCode': diseaseDetails.code,
        'IsDeleted': false,
        'Id': 0,
      });
      this.setState({ diagnosisArray: arr });
    }
  }
  handleAddCPT = (formValues,isEditServiceCode) => {
    var isServerExists = false;
    var quantity = 0;
    //console.log('formValues...........',formValues)
    if(isEditServiceCode){
      if (formValues.AuthProcedureCPTLinkId) {
        let postData = {
          appointmentId: this.state.apptid,
          authProcedureCPTLinkId: formValues.AuthProcedureCPTLinkId,
          serviceCodeId: 0,
          unitToBlock: 0,
          actionName: 'delete',
        };       
        this.props.updateServiceCodeBlockedUnits(postData);
      }      
      // console.log('this.state.CPTTableData...........',this.state.CPTTableData)
      let index =this.state.CPTTableData.findIndex((Obj) => Obj.AuthProcedureCPTLinkId === formValues.AuthProcedureCPTLinkId);
      // console.log('index...........',index)
      Alert.closeAll();
      if (index > -1) {
        let arr = this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted);
        //if (arr[index].AuthProcedureCPTLinkId > 0) {
          arr[index].IsDeleted = true;
        //} else {
          arr.splice(index, 1);
        //}
        // console.log('arr..........',arr)
        this.setState({ CPTTableData: arr });
      }
    }
    else
    {
      let index =this.state.CPTTableData.findIndex((Obj) => Obj.AuthProcedureCPTLinkId === formValues.AuthProcedureCPTLinkId && ((Obj.Modifier1 === undefined && formValues.Modifier1 === undefined) || Obj.Modifier1 === formValues.Modifier1) && ((Obj.Modifier2 === undefined && formValues.Modifier2 === undefined) || Obj.Modifier2 === formValues.Modifier2) && ((Obj.Modifier3 === undefined && formValues.Modifier3 === undefined) || Obj.Modifier3 === formValues.Modifier3) && ((Obj.Modifier4 === undefined && formValues.Modifier4 === undefined) || Obj.Modifier4 === formValues.Modifier4));
      //index =this.state.CPTTableData.findIndex((Obj) => Obj.AuthProcedureCPTLinkId === formValues.AuthProcedureCPTLinkId);
      Alert.closeAll();
      if (index > -1) {
        let arr = this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted);
       // if (arr[index].AuthProcedureCPTLinkId > 0) {
          //arr[index].IsDeleted = true;
          arr[index].Quantity = parseInt(arr[index].Quantity) + parseInt(formValues.Quantity);
          quantity = arr[index].Quantity;
          isServerExists = true;
       // } 
        //console.log('arr..........',arr)
        this.setState({ CPTTableData: arr });
      }
    }

    //console.log('quantity...........',quantity)
    
    if(isServerExists)
    {
      if (formValues.AuthProcedureCPTLinkId) {
        let postData = {
          appointmentId: this.state.apptid,
          authProcedureCPTLinkId: formValues.AuthProcedureCPTLinkId,        
          serviceCodeId: formValues.ServiceCodeId,
          //unitToBlock: formValues.Quantity,
          unitToBlock: quantity,
          actionName: 'updateexistingservicecode',
        };

        this.props.updateServiceCodeBlockedUnits(postData);
      }
      if(this.state.showCompleteButton)
      {
          var link = document.getElementById('btnComplete');      
          if(link)      
            link.click();  
      }
      else
      {
        // if(this.state.isFormSubmitted && this.state.appointmentTypeIsBillable === true)
        // {
          //save 
          var link = document.getElementById('btnSave');      
          if(link)      
            link.click(); 
        // }
        // else
        // {
        //   //save as draft
        //   var link = document.getElementById('btnSaveAsDraft');      
        //   if(link)      
        //     link.click();  
        // }
      }
    }
    else
    {
      if (formValues.AuthProcedureCPTLinkId) {
        let postData = {
          appointmentId: this.state.apptid,
          authProcedureCPTLinkId: formValues.AuthProcedureCPTLinkId,        
          serviceCodeId: formValues.ServiceCodeId,
          unitToBlock: formValues.Quantity,
          actionName: 'add',
        };
        this.props.updateServiceCodeBlockedUnits(postData);
      }
      let cptObj = extractDataFromArray(this.state.master_data.masterServiceCode, formValues.ServiceCodeId);
      // console.log('cptObj...........',cptObj)
      let arr = this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted);
      // console.log('arr111...........',arr)
      if (arr.indexOf(cptObj) === -1) {
        arr.push({
          'AuthProcedureCPTLinkId': formValues.AuthProcedureCPTLinkId,
          'AuthorizationNumber': formValues.AuthorizationNumber,
          'ServiceCodeId': cptObj.id,
          'ServiceCode': cptObj.serviceCode,
          'Description': cptObj.description,
          'IsDeleted': false,
          'Id': 0,
          'Modifier1': formValues.Modifier1 ? formValues.Modifier1 : null,
          'Modifier2': formValues.Modifier2 ? formValues.Modifier2 : null,
          'Modifier3': formValues.Modifier3 ? formValues.Modifier3 : null,
          'Modifier4': formValues.Modifier4 ? formValues.Modifier4 : null,
          'AttachedModifiers': formValues.attachedModifiers,
          'Quantity': formValues.Quantity && parseInt(formValues.Quantity) > 0 ? parseInt(formValues.Quantity) : 0,
          'RemainingUnits': formValues.RemainingUnits,
        });

        this.setState({ CPTTableData: arr },()=>{          
          //console.log('CPTTableData1...........',this.state.CPTTableData)      
          if(this.state.showCompleteButton)
          {
              var link = document.getElementById('btnComplete');      
              if(link)      
                link.click();  
          }
          else
          {            
            //save 
            var link = document.getElementById('btnSave');      
            if(link)      
              link.click();             
          }
        });
      }
    }
    
  }
  handleAddSign = (formProps) => {

    let signBytes = formProps.signBytes.substring(22);
    let data = {
      Bytes: signBytes,
      Date: moment().format('YYYY-MM-DDTHH:mm:ss'),
      Name: '',
      Latitude: 0.0,
      Longitude: 0.0,
    };
    switch (formProps.Signee) {
    case 1:
      data.id = this.state.EmployeeSign.id || null;
      data.Name = extractNameFromArray(this.state.signatureStaffs, formProps.StaffID);
      data.Latitude = this.props.latitude;
      data.Longitude = this.props.longitude;
      this.setState({ EmployeeSign: data });
      this.filter.isEmployeeSigned = true;
      this.saveEncounterSigns(data.id, data, null, null, null);
      break;
    case 2:
      data.id = this.state.ClientSign.id || null;
      data.Name = this.state.patientName;
      data.Latitude = this.props.latitude;
      data.Longitude = this.props.longitude;
      this.setState({ ClientSign: data });
      this.filter.isClientSigned = true;
      this.saveEncounterSigns(data.id, null, data, null, null);
      break;
    case 3:
      data.id = this.state.GuardianSign.id || null;
      data.Name = formProps.Guardian;
      data.Latitude = this.props.latitude;
      data.Longitude = this.props.longitude;
      this.setState({ GuardianSign: data });
      this.filter.isGuardianSigned = true;
      this.saveEncounterSigns(data.id, null, null, data, null);
      break;
    case 4:
      data.id = this.state.RenderingProviderSign.id || null;
      //data.Name = extractNameFromArray(this.state.signatureRenderingProviders, formProps.RenderingProviderID);
      data.Name = formProps.SupervisingClinician;
      data.Latitude = this.props.latitude;
      data.Longitude = this.props.longitude;
      this.setState({ RenderingProviderSign: data });
      this.filter.isRenderingProviderSigned = true;
      this.saveEncounterSigns(data.id, null, null, null, data);
      break;
    default:
      break;
    }

    this.setState({ isAllSigned: this.checkIsAllRequiredSigned() });
  }


  reasonCodeGetter = (reasonCode)=>{
      this.setState({reasonCodeState:reasonCode})
  }

  noteDataGetter = (formdata)=>{
    this.setState({soapNoteDataFromModal:formdata})
    
  }

  checkIsAllRequiredSigned() {
    let employee_Signed = true, client_signed = true, guardian_signed = true, rederingProvider_signed = true;
    if (this.state.signRequired.employee_sign) {
      if (this.filter.isEmployeeSigned) {
        employee_Signed = true;
      } else {
        employee_Signed = false;
      }
    }
    if (this.state.signRequired.client_sign && this.state.isBillableEncounter) {
      if (this.filter.isClientSigned) {
        client_signed = true;
      } else {
        client_signed = false;
      }
    }
    if (this.state.signRequired.guardian_sign) {
      if (this.filter.isGuardianSigned) {
        guardian_signed = true;
      } else {
        guardian_signed = false;
      }
    }
    if (this.state.signRequired.rederingProvider_sign) {
      if (this.filter.isRenderingProviderSigned) {
        rederingProvider_signed = true;
      } else {
        rederingProvider_signed = false;
      }
    }
    
    // finally check if all required are signed ...
    if (employee_Signed && client_signed && guardian_signed && rederingProvider_signed) {
      return true;
    } else {
      return false;
    }
  }

  saveEncounterSigns(id = 0, employeeSign, patientSign, guradianSign, renderingProviderSign) {
    let postData = {
      id: id,
      patientEncounterId: this.state.encounterId,
      patientId: patientSign ? this.state.patient_id : null,
      patientSign: patientSign ? patientSign.Bytes : null,
      patientSignDate: patientSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      staffId: employeeSign ? this.state.staffID : null,
      clinicianSign: employeeSign ? employeeSign.Bytes : null,
      clinicianSignDate: employeeSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      guardianName: guradianSign ? guradianSign.Name : null,
      guardianSign: guradianSign ? guradianSign.Bytes : null,
      guardianSignDate: guradianSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      //staffId: renderingProviderSign ? this.state.renderingProviderID : null,
      renderingProviderName: renderingProviderSign ? renderingProviderSign.Name : null,
      renderingProviderSign: renderingProviderSign ? renderingProviderSign.Bytes : null,
      renderingProviderSignDate: renderingProviderSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      latitude: this.props.latitude ? this.props.latitude : 0.0,
      longitude: this.props.longitude ? this.props.longitude : 0.0,
    };
    // console.log(JSON.stringify(postData));
    this.props.saveEncounterSigns(postData);
  }

  // componentDidUpdate() {
  //   if(this.state.isGenerateClaimAfterRendered)
  //   {     
  //     var link = document.getElementById('btnComplete');      
  //     if(link)      
  //       link.click();            
  //   }    
  // }

  handleGetSessionNoteDetailsFromLastSessionCheck = (input, name) => {
    if(input.target.checked)
    {
      this.props.getPreviousSessionNotesDetails(this.state.apptid, this.state.appointmentTypeID, this.state.patient_id, this.state.staffID);

    }
  }
  render() {
    const { handleSubmit } = this.props;
    
    // const tableClass = classNames({
    //   'table': true,
    //   'table-striped': this.props.bordered,
    //   'table-bordered': this.props.bordered,
    //   'table-hover': true,
    //   'table-condensed': this.props.condensed,
    //   'customtable': true,
    // });
    const handleGenerate = (e, index) => {
        let alertConfig = {
          customButtons: [{
            name: 'Confirm',
            handleClick: handleSubmit(this.handleGenerateAISummary),
            param: {
              id: index,
            },
          }, {
            name: 'Cancel',
            handleClick: () => Alert.closeAll(), 
            param: {
              id: index,
            },
          }],
        };
        alertConfirmation('The summary data generated here will override the existing summary data.', alertConfig);
      }
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });
    let totalUnitsConsumed = (this.state.get_soap && this.state.get_soap.unitsConsumed) || 0;
    let canOnlyAddSignForTheirNotes = true;
    if (this.props.canOnlyAddSignForTheirNotes && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)){
      canOnlyAddSignForTheirNotes = this.props.currentLoginUserId === this.state.staffID;
    }
    return (
      <div>
        <h2 className="page_title">Visit Details</h2>
        {this.state.patient_id ?
          <PatientInfo patientId={this.state.patient_id} />
          : ''}
        {this.state.open ?
          <ProblemModal soapPage = {this.state.soapPage} diagnosisArray={this.state.diagnosisArray} master_data={this.state.master_data} closeDialog={this.handleClose} handleAddDiagnosis={this.handleAddDiagnosis} />
          : null}
        {this.state.openCPT ?
          <CPTModal soapPage = {this.state.soapPage} patientId={this.state.patient_id} dateOfService={this.state.DateOfService} cptArray={this.state.CPTTableData} master_CPT = {this.state.master_data.masterServiceCode ? this.state.master_data.masterServiceCode : this.props.master_data.masterServiceCode} patientInsuranceId={this.state.patientInsuranceId} closeDialog={this.handleCloseCPT} handleAddCPT={this.handleAddCPT} isEditServiceCode = {this.state.isEditServiceCode} CPTSingleData = {this.state.CPTSingleData} apptid={this.state.apptid} />
          : null}
        {this.state.openSign ?
            this.props.agencyName.toUpperCase() === 'TBC5' ?
            <SignatureModal staffID={this.state.staffID} clientName={this.state.patientName} staffs={this.state.signatureStaffs} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />          
            :
            <SignatureWithRenderingProviderModal staffID={this.state.staffID} renderingProviderID={this.state.renderingProviderID} clientName={this.state.patientName} staffs={this.state.signatureStaffs} renderingProviders={this.state.signatureRenderingProviders} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />                      
          : null}
          {this.state.openUploadDocument ? <UploadDocumentModal  uploadDocumentObj={this.state.uploadDocumentObj} closeDialog={this.handleCloseHandler}  PatientAppointmentId = {this.state.apptid} PatientEncounterId = {this.state.encounterId} /> : ''}      
          {this.state.openSessionAuditLogModal ? <SessionAuditLogModal appointmentId={this.state.apptid} isBillableSession={true} closeDialog={() => this.handleCloseSessionAuditLogModal()}/> : null}
            
        <div className="clearfix"></div>
        <div className="readmin-panel mt-15">
          <div className="panel-body">
          <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              <div className="row">
              {this.state.isEvvPayer ? (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '1vh', 
                  textAlign: 'center'
                }}>
                  <span style={{ color: "rgb(250,187,61)" }}>
                    This is an EVV Payer. Please render this session from the mobile app.
                  </span>
                </div>
              ) : null} 
                <div className="col-8 col-sm-8 col-md-8">
                  {this.state.isGenerateClaimAfterRendered ?
                    <div className={'alert alert-danger-soap update-pwd'}>
                        <strong>**YOU MUST SCROLL DOWN AND CLICK ON THE COMPLETE BUTTON TO SAVE YOUR CHANGES. <br/> CHANGES MAY NOT BE SAVED UNLESS YOU CLICK COMPLETE! <br/> IF THERE IS NO COMPLETE BUTTON THEN YOUR CHANGES HAVE BEEN SAVED AUTOMATICALLY. **</strong>
                    </div>
                    : 
                    <CommonButton className="mb-20" label="Go back to scheduler" primary={true} onTouchTap={this.handleCancel} />
                   }                 
                </div>
              
                <div className="col-2 col-sm-2 col-md-2 btn_rt">
                  {/* {
                    this.props.agencyName.toUpperCase() !== 'BASICS' ? (
                      !this.state.isEvvPayer ? (
                        this.state.showClockInClockOut ? (
                          <CommonButton
                            className="mb-20"
                            label="Clock In"
                            disabled={this.state.clockInDateTime ? true : false}
                            primary={true}
                            onTouchTap={this.handleClockIn}
                          />
                        ) : null 
                      ) : null
                    ) : null
                  }       
                   */}
                    {(this.props.agencyName.toUpperCase() !== 'BASICS') && (!this.state.isEvvPayer) && (this.state.showClockInClockOut==="true")?
                      <CommonButton className="mb-20" label="Clock In" disabled={this.state.clockInDateTime ? true : false} primary={true} onTouchTap={this.handleClockIn} />                    
                    : null}
                </div>
                <div className="col-2 col-sm-2 col-md-2 btn_rt">                    
                    {(this.props.agencyName.toUpperCase() !== 'BASICS')  && !this.state.isEvvPayer && this.state.showClockInClockOut==="true"?
                      <CommonButton className="mb-20" label="Clock Out" disabled={this.state.clockOutDateTime ? true : false} primary={true} onTouchTap={this.handleClockOut} />                    
                    : null}
                </div>
              </div>
              {this.state.lastUpdatedBy && <div className="row">
                <div className="col-12 col-sm-12 col-md-12">
                <div className="client_profile">                              
                    <div className="userlinks">
                      {/* {console.log('this.state.lastUpdatedDate...............',this.state.lastUpdatedDate)}*/}
                    <p><a href="#" onClick={(e) => this.handleOpenSessionAuditLog(e)}><u>Last Edited</u>:</a> {showFormatedDateandTimeForSessionLogs(this.state.lastUpdatedDate)} By {this.state.lastUpdatedBy}</p>                                                                 
                    </div>                       
                    {/* {((moment(showFormatedDateandTime(this.props.employeeSignDate || this.state.EmployeeSign.Date),"MM/DD/YYYY hh:mm").isBefore(moment(showFormatedDateandTime(this.state.lastUpdatedDate),"MM/DD/YYYY hh:mm"))) || (moment(showFormatedDateandTime(this.props.guardianSignDate || this.state.GuardianSign.Date),"MM/DD/YYYY hh:mm").isBefore(moment(showFormatedDateandTime(this.state.lastUpdatedDate),"MM/DD/YYYY hh:mm")))) ?                        
                    <div className="client_detail custm_appointmenttype">
                        <span>*The appointment was modified after signatures. Please obtain new signatures*</span>
                    </div> : null}                  */}
                </div>
                </div>
              </div>}
              {this.props.agencyName.toUpperCase() === CWO || this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === FUTURES || this.props.agencyName.toUpperCase() === 'ACT' || this.props.agencyName.toUpperCase() === IAT || this.props.agencyName.toUpperCase() === 'EXPLOREABA' || this.props.agencyName.toUpperCase() === 'SPROUT'  ? 
              <div className="row">
                <div className="col-6 col-sm-6 col-md-6 mb-20">
                    <Field className="mt20 mb0 custm_check"
                          name="isGetSessionNoteDetailsFromLastSession"
                          label="Get Session Note details from last session"
                          disabled={this.state.encounterId > 0 ? true : false}
                          onChange={(e) => this.handleGetSessionNoteDetailsFromLastSessionCheck(e, 'ActiveClient')}
                          component={renderCheckBox}
                        />
                </div>
                <div className="col-6 col-sm-6 col-md-6"></div>
              </div>:null} 
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p className="wd-100">
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                      <p>
                        <b>Payer Name :</b> <span>{this.state.payerName ? this.state.payerName : '-'}</span>
                      </p>
                      <p>
                        <b>Client Name :</b> <span>{this.state.patientName ? this.state.patientName : '-'}</span>
                      </p>
                      <p>
                        <b>Supervising Clinician Name :</b> <span>{this.state.renderingProviderName ? this.state.renderingProviderName : '-'}</span>
                      </p> 
                      {this.props.agencyName.toUpperCase() === 'PEDERECINC' ?                
                        <p>
                          <b>Session Duration (In Hrs):</b> <span>{this.state.timeDifference}</span>
                        </p>: null}    
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    fullWidth={true}
                    // disabled={this.state.isSoapCompleted}
                    disabled={true}
                    component={renderTimePicker}
                    selected={this.state.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    // disabled={this.state.isSoapCompleted}
                    disabled={true}
                    component={renderTimePicker}
                    selected={this.state.serviceEndTime}
                    onDateChange={this.onDateChange}
                    fullWidth={true}
                  />
                </div>
              </div>
              <div className ="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Session Notes</h3>
                    <i className="flaticon flaticon-bathroom"></i>
                  </div>
                </div>
                {/* <div className={this.state.isFormSubmitted && this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'} > */}
                <div className='col-sm-12 require'>
                  <Field
                    name="subjective"
                    type="text"
                    fullWidth={true}
                    label="Subjective"
                    rowsCount = {6}
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderTextArea}
                    validate={this.state.isFormSubmitted && this.state.appointmentTypeIsBillable === true ? [validateSubjective] : null}
                    onChange={(e) => this.handleFieldChange('subjective',e.target.value)}
                  />
                </div>
                {/* <div className={this.state.isFormSubmitted && this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'}> */}
                <div className='col-sm-12 require'>
                  <Field
                    name="objective"
                    type="text"
                    fullWidth={true}
                    label="Objective"
                    rowsCount = {6}
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderTextArea}
                    validate={this.state.isFormSubmitted && this.state.appointmentTypeIsBillable === true ? [validateObjective] : null}
                    onChange={(e) => this.handleFieldChange('objective',e.target.value)}
                  />
                </div>
                {/* <div className={this.state.isFormSubmitted && this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'}> */}
                <div className='col-sm-12 require'>
                  <Field
                    name="assessment"
                    type="text"
                    fullWidth={true}
                    label="Assessment"
                    rowsCount = {6}
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderTextArea}
                    validate={this.state.isFormSubmitted && this.state.appointmentTypeIsBillable === true ? [validateAssessment] : null}
                    onChange={(e) => this.handleFieldChange('assessment',e.target.value)}
                  />
                </div>
                {/* <div className={this.state.isFormSubmitted && this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'}> */}
                <div className='col-sm-12 require'>
                  <Field
                    name="plans"
                    type="text"
                    fullWidth={true}
                    label="Plan"
                    rowsCount = {6}
                    // autoHeight={true}
                    disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                    component={renderTextArea}
                    validate={this.state.isFormSubmitted && this.state.appointmentTypeIsBillable === true ? [validatePlans] : null}
                    onChange={(e) => this.handleFieldChange('plans',e.target.value)}
                  />
                </div>
                {this.props.appConfigAIGenerateSetting && this.props.appConfigAIGenerateSetting.value === 'true' ?
                  // <div className={this.state.isFormSubmitted && this.state.appointmentTypeIsBillable === true ? 'col-sm-12 require' : 'col-sm-12'}>
                  <div className='col-sm-12 require'>
                    <Field
                      name="narrativeSummary"
                      maxLength="4000"
                      type="text"
                      fullWidth={true}
                      label="Narrative Summary"
                      rowsCount = {6}
                      disabled={this.state.isSoapCompleted || this.state.isSessionPending}
                      component={renderTextArea}
                      validate={this.state.isFormSubmitted && this.state.appointmentTypeIsBillable === true ? [validateNarrativeSummary] : null}
                    />
                  </div> 
                : null}
                {this.props.appConfigAIGenerateSetting && this.props.appConfigAIGenerateSetting.value === 'true' ? 
                  <div className="col-sm-4 pdl-30">
                      {/* <RaisedButton className="soapmodal_btn" label="Generate AI" primary={true}
                      disabled = {!this.state.isGenerateAIDisabled} */}
                      {!this.state.isGenerateAIDisabled && this.props.initialValues === null && this.state.isTooltipVisible && (
                        <Tooltip
                          label="Please fill in all mandatory fields above" 
                          show={true} 
                          style={{ position: 'absolute', top: '-10px' }}
                        />
                      )}
                      <RaisedButton
                        className="soapmodal_btn ml-3"
                        label={this.state.isGeneratingNarrativeSummary ? "Generating..." : "Generate AI summary"}
                        disabled={(!this.state.isGenerateAIDisabled && this.props.initialValues === null) || this.state.isSoapCompleted || this.state.isSessionPending}                        
                        onMouseEnter={this.handleMouseEnter}  
                        onMouseLeave={this.handleMouseLeave}  
                        backgroundColor="#09a9dc"  
                        labelColor="#ffffff"  
                        onTouchTap={this.props.isGeneratingNarrativeSummary !== undefined || (this.props.initialValues && this.props.initialValues.narrativeSummary !== null)? handleSubmit(handleGenerate) : handleSubmit(this.handleGenerateAISummary)}
                      />
                  </div>  
                : null}
              </div>
            </form>
            <div className = "row">
              <div className="col-sm-12">
                <div className="panel_title mt-24  mb-20">
                  <h3>Diagnosis</h3>
                  <i className="flaticon flaticon-gym"></i>
                </div>
              </div>
              {/* {this.props.addPermission && !this.state.isSoapCompleted ?
                <div className="col-sm-12 pdl-30">
                  <CommonButton className="soapmodal_btn" label="Add Diagnosis" primary={true} onTouchTap={this.handleOpen} />
                </div>
                : null} */}
            </div>
            <div className="table-responsive mt-15">
              <Table className={tableClass1}
                height={this.state.height}
                fixedHeader={this.state.fixedHeader}
                fixedFooter={this.state.fixedFooter}
                selectable={this.state.selectable}
                multiSelectable={this.state.multiSelectable}
              >
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                      <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                      <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                      {/* <TableHeaderColumn width="30%">Diagnosis Date</TableHeaderColumn> */}
                    {/* {!this.state.isSoapCompleted ?
                      <TableHeaderColumn>Action</TableHeaderColumn>
                      : null} */}
                    {/* <TableHeaderColumn width="20%">Attach</TableHeaderColumn>*/}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={this.state.deselectOnClickaway}
                  showRowHover={this.state.showRowHover}
                  stripedRows={this.state.stripedRows}
                >
                  {this.renderDiagnosis()}
                </TableBody>
              </Table>
            </div>
            <div className = "row">
              <div className="col-sm-12">
                <div className="panel_title mt-24  mb-20">
                  <h3>Service Codes</h3>
                  <i className="flaticon flaticon-interface-2"></i>
                </div>
              </div>
            </div>
            {(this.props.agencyName.toUpperCase() === CWO || this.props.agencyName.toUpperCase() === IAT || this.props.agencyName.toUpperCase() === VIP) && this.props.addPermission && !this.state.isSoapCompleted && !this.state.IsHideOnlyCompleteButton ?
              <div className = "row">
                <div className="col-sm-4 pdl-30">
                  <RaisedButton className="soapmodal_btn" label="Add Service Codes" primary={true} onTouchTap={this.handleOpenCPT} />
                </div>                
                <div className="col-sm-6 mt-10 custm_clientinsurance">                    
                </div>
              </div>: null}
            <div className="mt-15">
              <Table className={tableClass1}
                height={this.state.height}
                fixedHeader={this.state.fixedHeader}
                fixedFooter={this.state.fixedFooter}
                selectable={this.state.selectable}
                multiSelectable={this.state.multiSelectable}
              >
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <TableHeaderColumn>Service Code</TableHeaderColumn>
                    <TableHeaderColumn>Modifiers</TableHeaderColumn>
                    <TableHeaderColumn>Units</TableHeaderColumn>
                    <TableHeaderColumn>Description</TableHeaderColumn>
                    {this.props.deletePermission && !this.state.isSoapCompleted && !this.state.IsHideOnlyCompleteButton ?
                      <TableHeaderColumn width="10%">Action</TableHeaderColumn>
                      : null}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={this.state.deselectOnClickaway}
                  showRowHover={this.state.showRowHover}
                  stripedRows={this.state.stripedRows}
                >
                  {this.renderCpt()}
                </TableBody>
              </Table>
            </div>

             {this.state.isDataCollectionEnabledForAgency && <div>
              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-10 mb-10">
                    <h3>Skill Acquisition Data :</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              
              </div>
              <div className="table-responsive mt-15">
                <Table className={tableClass1}
                  height={this.state.dataCollectionHeight}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                        <TableHeaderColumn width="40%">Program Name</TableHeaderColumn>
                        <TableHeaderColumn width="40%">Target Name</TableHeaderColumn>
                        <TableHeaderColumn width="20%">Value</TableHeaderColumn>                      
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderSessionNotesSkillsAcquisition()}
                  </TableBody>
                </Table>
              </div>

              <div className = "row">
                <div className="col-sm-12">
                  <div className="panel_title mt-10 mb-10">
                    <h3>Behavior Reduction Data :</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              
              </div>
              <div className="table-responsive mt-10 mb-40">
                <Table className={tableClass1}
                  height={this.state.dataCollectionHeight}
                  fixedHeader={this.state.fixedHeader}
                  fixedFooter={this.state.fixedFooter}
                  selectable={this.state.selectable}
                  multiSelectable={this.state.multiSelectable}
                >
                  <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                  >
                    <TableRow>
                        <TableHeaderColumn width="40%">Behavior Name</TableHeaderColumn>
                        <TableHeaderColumn width="40%">Recording Type </TableHeaderColumn>
                        <TableHeaderColumn width="20%">Value</TableHeaderColumn>                      
                    </TableRow>
                  </TableHeader>
                  <TableBody
                    displayRowCheckbox={false}
                    deselectOnClickaway={this.state.deselectOnClickaway}
                    showRowHover={this.state.showRowHover}
                    stripedRows={this.state.stripedRows}
                  >
                    {this.renderSessionNotesBehaviorReduction()}
                  </TableBody>
                </Table>
              </div>
            </div> }

              {
                this.state.openRenderModal && <ConfirmationPopUpModal formProps = {this.formPropDataPusher} closeDialog={this.handleClose} sendReason = {this.reasonCodeGetter}  noteDataGetter = {this.noteDataGetter} onCompleteSoap = {handleSubmit(this.onCompleteSoap)}  isAdminUpdateAfterRendered ={this.state.isAdminUpdateAfterRendered}  apptid={this.state.apptid}   encounterId={this.state.encounterId} />
              }
            <div className="row">
              <div className={`col-sm-12 pt20 btn_rt ${this.state.showCompleteButton && 'scroll_btn'}`}>
                <CancelButton onTouchTap={this.handleCancel} />
                {this.state.showCompleteButton && canOnlyAddSignForTheirNotes ?
                  <CommonButton className="soapmodal_btn ml-3" label="Upload Documents" primary={true} onTouchTap={this.uploadDocumenthandler} />
                : ''}
                {(this.state.showCompleteButton && canOnlyAddSignForTheirNotes) || (!this.state.isBillableEncounter && this.state.encounterId > 0) ?
                  <CommonButton className="soapmodal_btn ml-3" label="Add Sign" primary={true} onTouchTap={this.handleOpenSign} />
                  : ''}

                {!this.state.isSoapCompleted && !this.state.IsHideOnlyCompleteButton ?
                  (<span>
                    {!this.state.showCompleteButton && <CommonButton  id="btnSaveAsDraft" onClick={handleSubmit(this.onSaveAsDraft)} className="ml-3" primary={true} label="Save As Draft" />} 
                    {this.state.showCompleteButton && this.state.isBillableEncounter ? 
                      <CommonButton id="btnComplete" className="ml-3 soapmodal_btn" label="Complete" primary={true} disabled={!this.state.isAllSigned} onClick={this.state.isEvvPayer?this.handleOpenConfirmationPopUpModal:handleSubmit(this.onCompleteSoap)}/>
                      : 
                      <CommonButton  id="btnSave" onClick={handleSubmit(this.onSubmit)} className="ml-3" primary={true} label="Save" />
                    }
                  </span>)
                  : ''}
              </div>
            </div>

            { this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes || this.state.RenderingProviderSign.Bytes ?
              <div className="row">
                <div className="col-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Signature</h3>
                    <i className="flaticon flaticon-medical-1"></i>
                  </div>
                </div>
                {
                  this.state.EmployeeSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageEmployee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                              <h3>{this.state.EmployeeSign.Name} {this.props.agencyName.toUpperCase() === ABCSPECTRUM ? <span>(Practitioner)</span> : <span>(Employee)</span>}</h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name ? this.state.ClientSign.Name : this.state.patientName} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.RenderingProviderSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageEmployee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.RenderingProviderSign.Bytes}`} alt={''} />
                              <h3>{this.state.RenderingProviderSign.Name} <span>(Supervising Clinician)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.RenderingProviderSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.RenderingProviderSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.RenderingProviderSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
              </div>
              : ''}

          </div>
        </div>
      </div>
    );
  }
};
Soap = reduxForm({
  form: 'soapForm',
  // validate,
  enableReinitialize: true,
})(Soap);

function mapStateToProps(state) {

  // Start For Role Permission
  let userActionPermission = [], lastUpdatedBy = '', lastUpdatedDate = '', employeeSignDate = '', guardianSignDate = '';
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'SCHEDULING');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'SCHEDULING_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_ADDCODES_IN_SOAP')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_DELETECODES_IN_SOAP')[0].permission : false;
  let modifyAfterRenderPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_MODIFYAPPOINTMENT_AFTER_RENDERING')[0].permission : false;
  let requiredGuardianSignForIndirectServicePermission = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_REQUIRED_GUARDIAN_SIGNATURE_FOR_INDIRECT_SERVICE')[0].permission : false;
  let canOnlyAddSignForTheirNotes = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_PRACTITIONER_CAN_ONLY_ADD_SIGN_FOR_THEIR_OWN_NOTES')[0].permission : false;
  // End For Role Permission

  let app_config = state.appConfig.appConfigList ? state.appConfig.appConfigList.data : null;
  let initialData = null;
  if (state.soap.get_soap) {
    let obj = state.soap.get_soap.data;
    lastUpdatedBy = obj.lastUpdatedBy;
    lastUpdatedDate = obj.lastUpdatedDate;
    employeeSignDate= obj.encounterSignature && obj.encounterSignature[0] ? obj.encounterSignature[0].clinicianSignDate : null;
    guardianSignDate= obj.encounterSignature && obj.encounterSignature[0] ? obj.encounterSignature[0].guardianSignDate : null;
    if (obj.soapNotes) {     
      initialData = {
        // serviceStartTime: obj.startDateTime,
        // serviceEndTime: obj.endDateTime,
        subjective: obj.soapNotes.subjective,
        objective: obj.soapNotes.objective,
        assessment: obj.soapNotes.assessment,
        plans: obj.soapNotes.plans,
        narrativeSummary: obj.soapNotes.narrativeSummary,

      };
    }
  }

  let appConfigAIGenerateSetting = []
  if (state.appConfig.appConfigList && state.appConfig.appConfigList.data && state.appConfig.appConfigList.data.length) {
    appConfigAIGenerateSetting = state.appConfig.appConfigList.data.find(data => data.key === 'GEN_AI_NARRATIVE_SUMMARY');
  }

  if (state.soap.saved_soap && state.soap.saved_soap.data) {
    //console.log('state.soap.saved_soap.data................',state.soap.saved_soap.data);
    let obj = state.soap.saved_soap.data;    
    lastUpdatedDate = obj.lastUpdatedDate;
  }

  if (state.soap.get_PreviousSessionNotesDetails) {
    let obj = state.soap.get_PreviousSessionNotesDetails.data;
    if (obj) {
      if(state.login.organizationDetails && state.login.organizationDetails.businessName.toUpperCase() === 'ACT') {
        initialData = {          
          objective: obj.objective,          
        };
      }
      else {
        initialData = {
          subjective: obj.subjective,
          objective: obj.objective,
          assessment: obj.assessment,
          plans: obj.plans,
          narrativeSummary: obj.narrativeSummary || '',
        };
      }      
    }
  }

  return {
    app_config: app_config,
    userLocationList: state.login.userLocationList,
    master_data: state.soap.master_data,
    patientData: state.patient.get_patient_byid,
    patientPrimaryDiagnosis: state.patient.patientPrimaryDiagnosis,

    loading: state.soap.loading || state.customSoap.loading,
    appointment: state.soap.appointment,
    get_soap: state.soap.get_soap,
    saved_soap: state.soap.saved_soap && state.soap.saved_soap.data ? state.soap.saved_soap.data : null,
    initialValues: initialData,
    currentLoginUserId: state.login.loginUserInfo && state.login.loginUserInfo.id,
    hasDefaultAccess: hasDefaultAccess,
    addPermission: addPermission,
    deletePermission: deletePermission,
    modifyAfterRenderPermission: modifyAfterRenderPermission,
    requiredGuardianSignForIndirectServicePermission: requiredGuardianSignForIndirectServicePermission,
    canOnlyAddSignForTheirNotes: canOnlyAddSignForTheirNotes,
    latitude: state.appConfig.latitude,
    longitude: state.appConfig.longitude,
    clockInLatitude: state.appConfig.clockInLatitude,
    clockInLongitude: state.appConfig.clockInLongitude,
    clockOutLatitude: state.appConfig.clockOutLatitude,
    clockOutLongitude: state.appConfig.clockOutLongitude,    
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    lastUpdatedBy: lastUpdatedBy,
    lastUpdatedDate: lastUpdatedDate,
    employeeSignDate: employeeSignDate,
    guardianSignDate: guardianSignDate,
    appConfigAIGenerateSetting,
    narrativeAISummaryResponse: state.soap.narrativeAISummaryResponse,
    narrativeAISummaryError: state.soap.narrativeAISummaryError,
    isGeneratingNarrativeSummary: state.soap.isGeneratingNarrativeSummary,
    previousLocation: state.scheduling.previousLocation
  };
}

export default connect(mapStateToProps, { getMasterData, getSoapAction, createClaimAction, getAppointmentById, savePatientSoapAction, updateServiceCodeBlockedUnits, getAppConfigList, getPatientProfileDetails, saveEncounterSigns, getGeoLocation, getGeoLocationClockIn, getGeoLocationClockOut, saveClockInTimeIntoAppointment, saveClockOutTimeIntoAppointment, getPreviousSessionNotesDetails, generateNarrativeSummary,change, clearNarrativeSummary })(Soap);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/soap/index.js